import { jsx as _jsx } from "react/jsx-runtime";
import { faInbox } from '@fortawesome/free-solid-svg-icons';
import { errandButtonUtils } from '../../errandButtonUtils';
import { ExecuteActionResult } from '../../ExecuteActionResult';
import { hideWhenReadOnlyRule } from '../commonRules';
import { LeaveInInboxModal } from './LeaveInInboxModal';
export const LeaveInInboxButton = {
    key: 'lamna_kvar',
    text: 'Lämna i inkorg',
    prio: 3,
    section: 'start',
    icon: faInbox,
    buttonStyle: 'success',
    ModalComponent: LeaveInInboxModal,
    onClick: async (row, inca, showModal, ctx, api)=>{
        const { isSuccess, result: { res, transitionShortname } } = await showModal();
        if (!isSuccess) {
            return;
        }
        const stateTransitionResult = await errandButtonUtils.performStateTransition(transitionShortname, ctx, api, res);
        if (!stateTransitionResult) {
            return;
        }
        api.setRootComponent(/*#__PURE__*/ _jsx(ExecuteActionResult, {
            title: "Ärendet sparades",
            isFinished: false,
            stateTransitionResult: stateTransitionResult
        }));
    },
    defaultRules: [
        hideWhenReadOnlyRule
    ]
};
